import { FlexibleLearningTypeIcon, Learning_Type, SubscriptionType } from '@app/enums/_index';

import { Factory } from './_factory';
import { FlexibleLearning } from '@app/models/_index';

/**
 * Create Flexible Learning Factory used by application
 * Creates instances of Flexible Learning Items.
 */
export class FlexibleLearningItemFactory implements Factory<FlexibleLearning> {
  flexibleLearningItems: FlexibleLearning[] = [];

  /**
   * Call and build static Flexible Learning Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Flexible Learning Items array
   */
  build(): void {
    this.flexibleLearningItems.push(
      new FlexibleLearning(
        Learning_Type.E_LEARNING,
        '',
        FlexibleLearningTypeIcon.E_LEARNING_ICON,
        'Self-paced modules featuring a mix of text-based and video material.'
      ),
      new FlexibleLearning(
        Learning_Type.SELF_STUDY,
        '',
        FlexibleLearningTypeIcon.SELF_STUDY_ICON,
        'You control when ebook training starts and when breaks are needed.'
      ),
      new FlexibleLearning(
        'Instructor-Led <br> (Virtual)',
        '',
        FlexibleLearningTypeIcon.INSTRUCTOR_LED_VIRTUAL_ICON,
        '<strong>Coming Soon!</strong> Online instructor-led courses tailored for specific roles and skill levels'
      )
    );
  }

  /**
   * Build static Flexible Learning Items array by a given subscription
   * @param subscriptionName - subscription
   */
  buildBySubscription(subscriptionName: string): void {
    this.flexibleLearningItems = [];
    if (subscriptionName && subscriptionName === SubscriptionType.POINTILLIST_SUBSCRIPTION) {
      this.flexibleLearningItems.push(
        new FlexibleLearning(
          Learning_Type.E_LEARNING,
          '',
          FlexibleLearningTypeIcon.E_LEARNING_ICON,
          'Self-paced modules featuring a mix of text-based and video material.'
        ),
        new FlexibleLearning(
          Learning_Type.SELF_STUDY,
          '',
          FlexibleLearningTypeIcon.SELF_STUDY_ICON,
          'You control when ebook training starts and when breaks are needed.'
        )
      );
    } else {
      // Else return the default collection
      this.build();
    }
  }

  /**
   * Return immutable or copy of Flexible Learning Items collection
   * @returns - a slice or copy of the static collection
   */
  getCollection(): FlexibleLearning[] {
    if (this.flexibleLearningItems && this.flexibleLearningItems.length === 0) {
      this.build();
    }
    return this.flexibleLearningItems.slice();
  }

  /**
   * Return immutable or copy of Flexible Learning Items collection by Subscription
   * @param subscriptionNameSlug - subscription slug
   * @returns - a slice or copy of the static collection
   */
  getCollectionBySubscription(subscriptionNameSlug: string): FlexibleLearning[] {
    this.buildBySubscription(subscriptionNameSlug);
    return this.flexibleLearningItems.slice();
  }
}
